var base = require('settings/payment-method-braintree');

Vue.component('spark-payment-method-braintree', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/payment-method-braintree.js